// Punkte, Level-Kurve und Fallgeschwindigkeit gemäß Spec (HANDOFF.md §3).

export const MAX_LEVEL = 9;
export const LOCK_DELAY_MS = 500;
export const MAX_LOCK_RESETS = 15;

const LINE_BASE: Record<number, number> = { 1: 40, 2: 100, 3: 300, 4: 1200 };

/** Punkte für n gelöschte Zeilen auf gegebenem Level. */
export function lineScore(cleared: number, level: number): number {
  return (LINE_BASE[cleared] ?? 0) * level;
}

export const SOFT_DROP_POINTS = 1; // pro Zeile
export const HARD_DROP_POINTS = 2; // pro Zeile
export const LOCK_BONUS = 4;

/** Level aus Gesamt-Zeilen, nie unter dem Startlevel, gedeckelt bei MAX_LEVEL. */
export function levelForLines(totalLines: number, startLevel: number): number {
  const byLines = Math.min(MAX_LEVEL, 1 + Math.floor(totalLines / 10));
  return Math.max(startLevel, byLines);
}

/** Fallintervall in ms für ein Level. */
export function fallInterval(level: number): number {
  return Math.max(90, 760 - (level - 1) * 62);
}
